module.exports = __webpack_public_path__ + "img/downLoad.5e22d49f.svg";